module.exports = "https://qp-assets.quero.com/assets/images/queropago.svg?009066ff34493b0044bc4d1cfdc6dd83";